import axios from 'axios'

const portfolioList = {
  data: function() {
    return {
      portfolios: [],
      portfolioGuid: ''
    }
  },
  created() {
    axios.get(`${process.env.VUE_APP_API}/api/v1/portfolio`,{
        params: {
          limit: 9999,
          status: 'PROCESSED'
        }
      }
    )
      .then((response) => {
        this.portfolios = response.data.content
        if (Array.isArray(this.portfolios) && this.portfolios.length > 0) {
          this.portfolioGuid = this.portfolios[0].guid
        }
      })
  }
}

export default portfolioList
